import { BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  judicalVerification: [{
    text: i18n.t('judicalLicenseVerification'),
    href: '/verification-services',
  }] as BreadCrumbModel[],
};

export default Breadcrumbs;
